export const currentDateAsString = (): string => {
    const today = new Date();
    const day = String(today.getDate()).padStart(2, '0'); // Ensure two digits
    const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = today.getFullYear();

    return `${day}/${month}/${year}`;
};

export const extractAndConvertFrom = (dateTime: string) => {
    if (!dateTime) {
        return '';
    }
    return dateTime.split(' ')[0].split('-').reverse().join('/');
};

export const isDatePast = (dateString: string) => {
    const [year, month, day] = dateString.split("-").map(Number);
    const inputDate = new Date(year, month - 1, day);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    inputDate.setHours(0, 0, 0, 0);

    return inputDate < today;
};

export const formatDateToBR = (date: string | null | undefined): string => {
    if (!date) return '';
    return new Date(date).toLocaleDateString('pt-BR');
};

/** dd/mm/aaaa a partir de date/ISO. Baseado em string (sem `new Date`), então NÃO
 *  aplica fuso — use para campos que são data-calendário (vencimento, emissão) e evite D-1. */
export const formatDateBR = (value: string | null | undefined): string => {
    if (!value) return '-';
    const m = value.match(/^(\d{4})-(\d{2})-(\d{2})/);
    return m ? `${m[3]}/${m[2]}/${m[1]}` : value;
};

/** dd/mm/aaaa HH:MM no fuso de São Paulo, a partir de um INSTANTE em UTC (ISO com offset).
 *  Use para timestamps (payment_date, movement_date) — a conversão de fuso é feita aqui. */
export const formatDateTimeBR = (value: string | null | undefined): string => {
    if (!value) return '-';
    return new Date(value).toLocaleString('pt-BR', {
        day: '2-digit', month: '2-digit', year: 'numeric',
        hour: '2-digit', minute: '2-digit', timeZone: 'America/Sao_Paulo',
    });
};

/** Hoje em aaaa-mm-dd, no fuso de quem está olhando a tela.
 *  Montado a partir dos componentes LOCAIS de propósito: `toISOString()` converte para UTC e
 *  devolveria ontem em qualquer horário depois das 21h no Brasil — justo quando se olha vencido. */
export const todayISO = (): string => {
    const d = new Date();
    const mes = String(d.getMonth() + 1).padStart(2, '0');
    const dia = String(d.getDate()).padStart(2, '0');
    return `${d.getFullYear()}-${mes}-${dia}`;
};

/** Data-calendário a `days` de hoje (negativo = passado), em aaaa-mm-dd.
 *  `new Date(ano, mês, dia + n)` normaliza virada de mês, ano e bissexto sozinho. */
export const shiftDaysISO = (days: number): string => {
    const hoje = new Date();
    const d = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate() + days);
    const mes = String(d.getMonth() + 1).padStart(2, '0');
    const dia = String(d.getDate()).padStart(2, '0');
    return `${d.getFullYear()}-${mes}-${dia}`;
};

export const formatDateFromBRToISO = (dateString: string): string => {
    if (!dateString)
        return '';
    const [day, month, year] = dateString.split('/');
    if (!day || !month || !year)
        return '';
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
}